<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
	import Vue from 'vue';
	export default {
		onLaunch: function() {
			// console.log('App Launch');
			uni.getSystemInfo({
				success: (e) => {
					Vue.prototype.platform = e.platform;
				}
			});
			// if(process.env.NODE_ENV === 'production'){
			// 	let model = uni.getSystemInfoSync().model;
			// 	console.log(model,222)
			// 	if(model!='PC'){
			// 		return;
			// 		location.assign('/h5/');
			// 	}
			// }
			// if(process.env.NODE_ENV === 'development'){
			// 	let model = uni.getSystemInfoSync().model;
			// 	if(model!='PC'){
			// 		return;
			// 		location.assign('/h5/');
			// 	}
			// }
		},
		onShow: function() {
			console.log('App Show')
		},
		onHide: function() {
			//console.log('App Hide')	
		}
	}
</script>

<style lang="scss">
	/*每个页面公共css */
	/* #ifndef APP-NVUE */
	@import 'styles/common.scss';
	@import 'styles/style.scss';
	// @import 'styles/icon.css';
	@import url("//at.alicdn.com/t/c/font_4294037_6h7a0pmhmx.css");
	/* #endif */
	  /*每个页面公共css */
	  html {
		font-size: 22px !important;
	  }
</style>